import React from 'react';
import './Home.css';
import ImageSlider from './ImageSlider';

const Home = () => {
  const scrollToNextSection = () => {
    const nextSection = document.getElementById('product-section');
    if (nextSection) {
      nextSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="home">
      <ImageSlider />
      <button className="cta-button" onClick={scrollToNextSection}>
        Know More
      </button>
    </div>
  );
};

export default Home;
